import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Page from 'src/shared-components/Page/Page';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { BreadCrumbs } from 'src/shared-components/design-system/BreadCrumbs';

import {
  AccordionHeaderContent,
  AccordionItemContentType
} from '../../api/types';
import Accordion from '../../shared-components/Accordion/Accordion';
import AccordionDefaultBody from '../../shared-components/Accordion/AccordionDefaultBody';
import AccordionDefaultHeader from '../../shared-components/Accordion/AccordionDefaultHeader';
import trns from './trns';
import useGTAG from '../../hooks/useGTAG';

const listContent = {
  answer1: <FormattedMessage {...trns.answer1} />,
  answer2: <FormattedMessage {...trns.answer2} />,
  answer3: <FormattedMessage {...trns.answer3} />,
  answer4: <FormattedMessage {...trns.answer4} />,
  answer5: <FormattedMessage {...trns.answer5} />,
  answer6: <FormattedMessage {...trns.answer6} />,
  answer7: <FormattedMessage {...trns.answer7} />,
  answer8: <FormattedMessage {...trns.answer8} />,
  answer9: <FormattedMessage {...trns.answer9} />,
  answer10: <FormattedMessage {...trns.answer10} />
};

const HelpPageContainer: FC = () => {
  const intl = useIntl();

  const listGroups = [
    {
      id: 'answer1',
      title: intl.formatMessage(trns.question1)
    },
    {
      id: 'answer2',
      title: intl.formatMessage(trns.question2)
    },
    {
      id: 'answer3',
      title: intl.formatMessage(trns.question3)
    },
    {
      id: 'answer4',
      title: intl.formatMessage(trns.question4)
    },
    {
      id: 'answer5',
      title: intl.formatMessage(trns.question5)
    },
    {
      id: 'answer6',
      title: intl.formatMessage(trns.question6)
    },
    {
      id: 'answer7',
      title: intl.formatMessage(trns.question7)
    },
    {
      id: 'answer8',
      title: intl.formatMessage(trns.question8)
    },
    {
      id: 'answer9',
      title: intl.formatMessage(trns.question9)
    },
    {
      id: 'answer10',
      title: intl.formatMessage(trns.question10)
    }
  ];

  const { trackGtagEvent } = useGTAG();
  return (
    <Page>
      <BreadCrumbs
        items={[
          {
            id: 'home',
            title: <FormattedMessage {...trns.homeBreadCrumb} />,
            href: '/'
          },
          {
            id: 'help',
            title: <FormattedMessage {...trns.answers} />,
            href: '/help'
          }
        ]}
      />
      <Constraints className="pb-12 px-5 x l:px-0">
        <p className="text-astronautBlue fs-header6-bold pb-10 pt-7">
          {' '}
          {<FormattedMessage {...trns.answers} />}{' '}
        </p>
        <div>
          <Accordion
            accordionList={listGroups.map((group) => ({
              header: group,
              body: listContent[group.id]
            }))}
            renderItem={(content) => <AccordionDefaultBody content={content} />}
            classNameButton="pt-3.5 pb-3.5 border-b border-periwinkleGray"
            classNameItem=""
            isClosedState={true}
            onToggleHandler={(title) => {
              trackGtagEvent('help_question', title, 'title');
            }}
            renderHeader={(
              header: AccordionHeaderContent,
              productsList: AccordionItemContentType[],
              active: boolean
            ) => (
              <AccordionDefaultHeader
                header={header}
                productsList={productsList}
                active={active}
              />
            )}
          />
        </div>
      </Constraints>
    </Page>
  );
};

export default HelpPageContainer;
